import { Box } from '@jfs/ui-new'
import { useCallback, useEffect } from 'react'
import EmptyView from '../../../comps/EmptyView'
import { useLazyApiData, useStores } from '../../../data/store'
import { style } from './styles'
import { TableView } from './TableView'
import { UserManagementTabInterface } from './UserManagementTabInterface'

const UserManagementTab = ({ hide }: UserManagementTabInterface) => {
  const { getUsersListApi, users, getMasterPermissionCheckboxData, mid, refreshTable, canUpdateUsersInUserManagement } =
    useStores((store) => ({
      getUsersListApi: store.userManagement.getUsersListApi,
      getMasterPermissionCheckboxData: store.userManagement.getMasterPermissionCheckboxData,
      users: store.userManagement.getUsers(),
      mid: store.user.selectedMid,
      refreshTable: store.userManagement.refreshTable,
      canUpdateUsersInUserManagement: store.userManagement.canUpdateUsersInUserManagement(),
    }))

  const [fetchUserList, fetchUserListHandler = { data: [], state: 'pending' }] = useLazyApiData(getUsersListApi)
  const loadingState = fetchUserListHandler.state === 'pending'
  const errorState = fetchUserListHandler?.data?.message ?? false
  const emptyMessage =
    fetchUserListHandler.state === 'fulfilled' && fetchUserListHandler?.data?.length === 0 ? 'No users found...' : ''

  const callUserManagementApi = useCallback(() => {
    const postData = {
      entityId: mid,
    }
    fetchUserList(postData)
  }, [fetchUserList, mid])

  // This will give the table list data and will be re triggered when refreshing is needed to be done.
  useEffect(() => {
    if (!hide && mid) {
      callUserManagementApi()
    }
  }, [callUserManagementApi, hide, mid, refreshTable])

  // Need to keep it separate because while refreshing we don't want master check list data to be fetched again.
  useEffect(() => {
    if (!hide) {
      getMasterPermissionCheckboxData()
    }
  }, [getMasterPermissionCheckboxData, hide])

  const returnUsers = useCallback(() => {
    if (!canUpdateUsersInUserManagement) {
      users.forEach(function (userData: any) {
        delete userData?.actions
      })
      return users
    } else {
      return users
    }
  }, [canUpdateUsersInUserManagement, users])

  if (hide) {
    return null
  }

  return (
    <Box {...style.superParent}>
      <EmptyView
        testID="empty_view"
        onRetry={callUserManagementApi}
        isLoading={loadingState}
        error={errorState}
        emptyMessage={emptyMessage}
        loadingMessage="Loading..."
        hide={!loadingState && !errorState && !emptyMessage}
        loaderColor={'BLUE'}
      />
      <TableView users={returnUsers()} show={!loadingState && !errorState && !emptyMessage} />
    </Box>
  )
}

export { UserManagementTab }
